module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "订单结算",
      "backFn": "true"
    },
    on: {
      "back": _vm.back
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": ".84rem"
    }
  }, [_c('buyer-address', {
    attrs: {
      "addressInfo": _vm.addressInfo
    },
    on: {
      "changeAddressInfo": _vm.changeAddressInfo
    }
  })], 1), _vm._v(" "), _c('div', [_c('ul', {
    staticStyle: {
      "margin-bottom": ".2rem"
    }
  }, [_vm._l((_vm.productList), function(item, index) {
    return _c('li', {
      key: index,
      staticClass: "vux-1px-b goods "
    }, [_c('div', {
      staticClass: "headPic"
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + item.thumbnail + '?x-oss-process=image/resize,w_120'
      }
    })]), _vm._v(" "), _c('div', [_c('p', [_vm._v(_vm._s(item.title)), (item.specLabel) ? _c('span', [_vm._v("(" + _vm._s(item.specLabel) + ")")]) : _vm._e(), (item.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.subTitle) + " "), _c('span', {
      staticClass: "num "
    }, [_c('small', [_vm._v("x")]), _vm._v(_vm._s(item.quantity))])]), _vm._v(" "), _c('p', [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(item.price)))])])])
  }), _vm._v(" "), _c('li', {
    staticClass: "vux-1px-b box3"
  }, [_vm._v("商品总金额 "), _c('span', {
    staticClass: "r"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.productsPrice)))])]), _vm._v(" "), (_vm.availableCoupons.length > 0) ? _c('li', {
    staticClass: "vux-1px-b box3"
  }, [_c('selector', {
    attrs: {
      "placeholder": "请选择优惠券",
      "title": "优惠券",
      "options": _vm.availableCoupons,
      "direction": "rtl"
    },
    on: {
      "on-change": _vm.updateCoupon
    },
    model: {
      value: (_vm.couponId),
      callback: function($$v) {
        _vm.couponId = $$v
      },
      expression: "couponId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.discount) ? _c('li', {
    staticClass: "vux-1px-b box3"
  }, [_vm._v("优惠金额 "), _c('span', {
    staticClass: "r"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.discount)))])]) : _vm._e(), _vm._v(" "), (!_vm.fixedFreight) ? _c('li', {
    staticClass: "vux-1px-b box3"
  }, [(_vm.availableShippingMethodsList.length == 1) ? _c('span', [_vm._v("配送方式 "), _c('span', {
    staticClass: "r"
  }, [_vm._v(_vm._s(_vm.shippingMethodName))])]) : _c('selector', {
    attrs: {
      "placeholder": "请选择配送方式",
      "title": "配送方式",
      "options": _vm.availableShippingMethodsList,
      "direction": "rtl"
    },
    on: {
      "on-change": _vm.updateFreight
    },
    model: {
      value: (_vm.shippingMethodId),
      callback: function($$v) {
        _vm.shippingMethodId = $$v
      },
      expression: "shippingMethodId"
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.fixedFreight) ? _c('li', {
    staticClass: "box3 shipping-method-rule"
  }, [(_vm.shippingMethod.freeShipping == 'amount') ? _c('span', [_vm._v("订单满￥" + _vm._s(_vm._f("fen2yuan")(_vm.shippingMethod.freeShippingAmount)) + "元包邮")]) : _vm._e(), _vm._v(" "), (_vm.shippingMethod.freeShipping == 'quantity') ? _c('span', [_vm._v("订单满" + _vm._s(_vm.shippingMethod.freeShippingQuantity) + "件包邮")]) : _vm._e(), _vm._v(" "), (_vm.shippingMethod.freightType == 'weight') ? _c('span', [_vm._v("计重: 首重￥" + _vm._s(_vm._f("fen2yuan")(_vm.shippingMethod.firstPrice)) + "/" + _vm._s(_vm._f("ke")(_vm.shippingMethod.firstWeight)) + "; 续重￥" + _vm._s(_vm._f("fen2yuan")(_vm.shippingMethod.additionalPrice)) + "/" + _vm._s(_vm._f("ke")(_vm.shippingMethod.additionalWeight)))]) : _vm._e(), _vm._v(" "), (_vm.shippingMethod.freightType == 'quantity') ? _c('span', [_vm._v("计件: 首件￥" + _vm._s(_vm._f("fen2yuan")(_vm.shippingMethod.firstItemPrice)) + "; 续件￥" + _vm._s(_vm._f("fen2yuan")(_vm.shippingMethod.additionalItemPrice)) + "/件")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "vux-1px-b box3"
  }, [_vm._v("运费 "), _c('span', {
    staticClass: "r"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.freight)))])])], 2), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', [_vm._v("\n                合计:"), _c('span', {
    staticClass: "money"
  }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(_vm.totalPrice)))])]), _vm._v(" "), _c('div', {
    on: {
      "click": function($event) {
        _vm.createOrder()
      }
    }
  }, [_vm._v("\n                付款\n            ")])])]), _vm._v(" "), _c('confirm', {
    attrs: {
      "confirm-text": "确定放弃",
      "cancel-text": "再看看"
    },
    on: {
      "on-confirm": _vm.onBackConfirm
    },
    model: {
      value: (_vm.showBack),
      callback: function($$v) {
        _vm.showBack = $$v
      },
      expression: "showBack"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("是否放弃订单")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-233c2216"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CreateOrder/CreateOrder.vue
// module id = 528
// module chunks = 0